import type { Ref } from 'vue';

import { useQuery } from '@urql/vue';

import { fetchArticleQuizCollection } from '~/graphql/documents/learn/articles';

/**
 * Resolves the collection a quiz-landing article links to. Shared by the
 * public quiz card (hero image, coins, Start href) and the admin editor
 * (combobox label, title/description autofill). Waits server-side so the
 * public page SSRs the collection-driven furniture.
 */
export const useArticleQuizCollection = (collectionId: Ref<string>) => {
  const query = useQuery({
    query: fetchArticleQuizCollection,
    variables: computed(() => ({ id: collectionId.value })),
    pause: computed(() => !hasText(collectionId.value)),
  });

  onServerPrefetch(async () => {
    if (hasText(collectionId.value)) {
      await query;
    }
  });

  const collection = computed(() =>
    (hasText(collectionId.value) ? query.data.value?.learningAssetCollections.data[0] ?? null : null));

  return { collection };
};
